// extracted by mini-css-extract-plugin
export default {"item":"components-hotel-and-market-revenue-insight-dropdowns-chart-options-pace-module__item"};